import { useEffect, useState } from 'react';
import type { StorefrontProduct } from '../../shared/types/api';
import { ErrorNotice } from '../components/ErrorNotice';
import { LoadingTrail } from '../components/LoadingTrail';
import { StorefrontHeader } from '../features/storefront/StorefrontHeader';
import { api } from '../lib/api';
import { SIMULATED_TRAIL_DISCLOSURE } from '../lib/simulatedTrailDisclosure';
import { StoreFooter } from './StorefrontPage';

export function ProductPage({
  slug,
  navigate,
}: {
  slug: string;
  navigate: (path: string) => void;
}) {
  const [product, setProduct] = useState<StorefrontProduct | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    api
      .getStorefrontProduct(slug)
      .then(setProduct)
      .catch((reason: unknown) =>
        setError(reason instanceof Error ? reason.message : 'That product could not load.'),
      );
  }, [slug]);
  if (!product && !error) return <LoadingTrail message="Finding that trail…" />;
  return (
    <div className="store-shell">
      <StorefrontHeader navigate={navigate} />
      <main className="product-page">
        {error && <ErrorNotice message={error} />}
        {product && (
          <div className="product-detail">
            <div className="product-detail-art">
              {product.images[0] ? (
                <img src={product.images[0].url} alt={product.images[0].altText} />
              ) : (
                <span aria-hidden="true">✦</span>
              )}
              <small>Wild Trails animal experience artwork.</small>
            </div>
            <div className="product-detail-copy">
              <p className="store-kicker">{product.species.commonName}</p>
              <h1>{product.name}</h1>
              <p>{product.description}</p>
              <ul>
                <li>One bracelet product</li>
                <li>Standard {product.species.commonName} instruction card</li>
                <li>Adult-managed trail and daily learning experience</li>
                <li>No subscription</li>
              </ul>
              <p className="product-listing-status">
                Coming soon — Amazon listing not yet available.
              </p>
              <button className="store-text-button" type="button" onClick={() => navigate('/shop')}>
                All bracelets
              </button>
              <p className="store-plain-language">{SIMULATED_TRAIL_DISCLOSURE}</p>
            </div>
          </div>
        )}
      </main>
      <StoreFooter navigate={navigate} />
    </div>
  );
}
